import { Compass, Wind } from "lucide-react";
import { useLocation } from "react-router-dom";
import { districtForPath } from "./districts";

const conditions: Record<
  string,
  { weather: string; route: string; bearing: string }
> = {
  "garden-commons": {
    weather: "Blue-hour cloud veil",
    route: "Arrival ridge",
    bearing: "Lake basin",
  },
  "resident-quarter": {
    weather: "Warm window mist",
    route: "South-west houses",
    bearing: "West path",
  },
  "knowledge-terraces": {
    weather: "Clear lake wind",
    route: "Southern overlook",
    bearing: "Terrace path",
  },
  "market-quarter": {
    weather: "Golden shoreline breeze",
    route: "Western waterline",
    bearing: "Shore route",
  },
  "academy-ridge": {
    weather: "High ridge fog",
    route: "Upper village lane",
    bearing: "North rise",
  },
  "service-pavilion": {
    weather: "Cool road mist",
    route: "Service house road",
    bearing: "Upper route",
  },
};

export function DistrictHUD() {
  const { pathname } = useLocation();
  const district = districtForPath(pathname);
  if (pathname === "/") return null;

  const condition =
    conditions[district.districtId] ?? conditions["garden-commons"]!;

  return (
    <aside
      className="district-hud"
      data-district={district.districtId}
      aria-label={`${district.districtLabel} atmosphere`}
    >
      <div className="district-hud-orbit" aria-hidden="true">
        <i />
        <i />
      </div>
      <span className="district-hud-code">
        <Compass size={13} /> {district.sceneId}
      </span>
      <strong>{district.districtLabel}</strong>
      <small>{condition.route}</small>
      <div>
        <span>
          <Wind size={12} /> {condition.weather}
        </span>
        <span>{condition.bearing}</span>
      </div>
    </aside>
  );
}
